export class GameLoop {
  constructor({ onUpdate, onRender }) {
    this.onUpdate = onUpdate || (() => {});
    this.onRender = onRender || (() => {});

    this.rafId = null;
    this.lastTime = 0;
    this.isRunning = false;
    this.isPaused = false;

    this.tick = this.tick.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);

    document.addEventListener('visibilitychange', this.onVisibilityChange, false);
  }

  start() {
    if (this.isRunning) return;
    this.isRunning = true;
    this.isPaused = false;
    this.lastTime = performance.now();
    this.rafId = requestAnimationFrame(this.tick);
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    if (!this.isRunning) return;
    this.isPaused = false;
    this.lastTime = performance.now();
  }

  stop() {
    this.isRunning = false;
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  onVisibilityChange() {
    if (document.hidden) {
      this.isPaused = true;
    } else {
      // Resume and reset lastTime so dt doesn't explode
      this.lastTime = performance.now();
      this.isPaused = false;
    }
  }

  tick(currentTime) {
    if (!this.isRunning) return;

    this.rafId = requestAnimationFrame(this.tick);

    if (this.isPaused) {
      this.lastTime = currentTime;
      return;
    }

    let dt = (currentTime - this.lastTime) / 1000.0;
    this.lastTime = currentTime;

    // Clamp dt: minimum 0, maximum 0.1s (prevents large teleport jumps on lag spike)
    if (dt < 0) dt = 0;
    if (dt > 0.1) dt = 0.1;

    this.onUpdate(dt);
    this.onRender();
  }

  dispose() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }
}
